import React from 'react'

import VendorBillList from '../Bills/VendorBillList'

export default class BillVendorView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        }
    }

    componentDidMount() {

    }

    render() {
        return(
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="header col-md-6 col-sm-12 col-xs-12">
                            <h4 class="title">Bills</h4>
                            <p class="category">Complete list of all bills</p>
                        </div>
                        <VendorBillList />
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// app/components/Payables/Bill/BillVendorView.jsx